"use client";

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
    isSidebarOpen: boolean;
    activeTab: 'active' | 'projects';
}

const initialState: UIState = {
    isSidebarOpen: true,
    activeTab: 'active',
};

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
        setSidebarOpen: (state, action: PayloadAction<boolean>) => {
            state.isSidebarOpen = action.payload;
        },
        setActiveTab: (state, action: PayloadAction<'active' | 'projects'>) => {
            state.activeTab = action.payload;
        },
    },
});

export const { toggleSidebar, setSidebarOpen, setActiveTab } = uiSlice.actions;
export default uiSlice.reducer;
